import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBank = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M2.625 11.375H5.25v7H3.5a.875.875 0 0 0 0 1.75h21a.875.875 0 1 0 0-1.75h-1.75v-7h2.625a.874.874 0 0 0 .458-1.62l-11.375-7a.875.875 0 0 0-.916 0l-11.375 7a.875.875 0 0 0 .458 1.62Zm4.375 0h3.5v7H7v-7Zm8.75 0v7h-3.5v-7h3.5Zm5.25 7h-3.5v-7H21v7ZM14 4.527l8.284 5.098H5.716L14 4.527ZM27.125 22.75a.875.875 0 0 1-.875.875H1.75a.875.875 0 1 1 0-1.75h24.5a.875.875 0 0 1 .875.875Z" />
  </svg>
);
export default SvgBank;
